/** Fortify Terms of Use */

import { GENERAL_INQUIRIES_EMAIL } from "lib/fortifyContact";

export const termsOfServiceMeta = {
  company: "FORTIFY PORTAL, INC.",
  title: "Terms of Use",
  contactLine: `fortifyportal.ca | ${GENERAL_INQUIRIES_EMAIL}`,
};

export const termsOfServiceIntro =
  'These Terms of Use govern your access to and use of the Fortify portal (the "Platform"), operated by Fortify Portal, Inc. ("Fortify"). By accessing or using the Platform, you agree to these Terms of Use.';

export const termsOfServiceSections = [
  {
    number: "1",
    title: "About Fortify",
    paragraphs: [
      "Fortify is a start-up crowdfunding portal operated by Fortify Portal, Inc. Fortify does not provide advice about the suitability or the merits of any investment and does not make recommendations. Issuers offering securities through the Platform rely on the start-up prospectus exemption in National Instrument 45-110 (\"NI 45-110\"). Fortify's regulatory status, how it holds investor funds, our principals, and our wind-down process are set out on our Disclosures page.",
    ],
  },
  {
    number: "2",
    title: "Who May Use the Platform",
    paragraphs: [
      "You may subscribe for securities through the Platform only if you are a resident of a jurisdiction in Canada in which Fortify has filed the documents required under NI 45-110, and are of legal age in your jurisdiction of residence. Fortify facilitates only start-up crowdfunding distributions under NI 45-110 and no other distributions.",
    ],
  },
  {
    number: "3",
    title: "Offering Documents and Risk Acknowledgement",
    paragraphs: [
      "Before you can subscribe, Fortify makes the issuer's Form 45-110F1 Offering Document available to you and requires you to complete a Form 45-110F2 Risk Acknowledgement confirming that you have read and understood the offering document and the risk warnings. Investing in start-up and early-stage businesses is risky, and you may lose the entire amount you invest.",
    ],
  },
  {
    number: "4",
    title: "Withdrawal and Refunds",
    paragraphs: [
      "You may withdraw from an agreement to purchase a security by delivering a notice to Fortify not later than midnight on the second business day after you enter into the agreement, and again within the same period after Fortify notifies you of any amendment to the offering document. How Fortify holds and returns your funds is set out on our Disclosures page and in our Refund Policy.",
    ],
  },
  {
    number: "5",
    title: "No Fees Charged to Investors",
    paragraphs: [
      "Fortify does not charge any commission, fee, or other payment to investors.",
    ],
  },
  {
    number: "6",
    title: "Related Information and Policies",
    paragraphs: [
      "Our Disclosures page, Privacy Policy, and Refund Policy form part of your use of the Platform. Information about Fortify and our principals is set out on the Disclosures page; your personal information is handled in accordance with the Privacy Policy; and the return and refund of funds is governed by the Refund Policy.",
    ],
  },
  {
    number: "7",
    title: "Contact",
    paragraphs: [
      "Fortify Portal, Inc.",
      "1377 The Queensway, Unit 101, Toronto, Ontario M8Z 1T1",
    ],
    contactLines: [
      {
        label: "Email:",
        value: GENERAL_INQUIRIES_EMAIL,
        href: `mailto:${GENERAL_INQUIRIES_EMAIL}`,
      },
      {
        label: "Website:",
        value: "fortifyportal.ca",
        href: "https://fortifyportal.ca",
      },
    ],
  },
];
